import type { JobStatus } from './jobStatus'

export interface JobBoardColumn {
  title: string
  statuses: JobStatus[]
}

/**
 * The technician jobs board: every job status grouped into the three things a
 * tech standing at the shelf needs to tell apart — not started, being worked,
 * ready to hand back.
 *
 * Terminal statuses (Invoiced, Cancelled) are deliberately absent: the board
 * shows live work, and those jobs have left the shop. Everything else must
 * appear in exactly one column, or a job silently vanishes from the board —
 * see jobBoard.test.ts, which is what makes adding a status safe.
 */
export const JOB_BOARD_COLUMNS: JobBoardColumn[] = [
  { title: 'Queued', statuses: ['NewJob', 'ReadyToWork'] },
  // Stalled work stays on the board rather than disappearing — it is still the
  // shop's problem. Keep every blocking status here.
  { title: 'Working', statuses: ['InProgress', 'Blocked', 'WaitingOnParts'] },
  {
    title: 'Ready',
    statuses: [
      'ReadyForCollection',
      'ReadyForCollectionUnsuccessful',
      'ReadyToInvoice',
    ],
  },
]

/** Statuses the board intentionally omits — the job is no longer live work. */
export const JOB_BOARD_EXCLUDED_STATUSES: JobStatus[] = ['Invoiced', 'Cancelled']
